import * as React from 'react';
import { useContext } from 'react';
import { useRouter } from 'next/router';
import Button from 'ap-admin-components/lib/Components/Button';
import Menu from 'ap-admin-components/lib/Components/Menu';
import MenuItem from 'ap-admin-components/lib/Components/MenuItem';
import { AuthContext } from '@/auth/Authentication';

export type Locale = 'et' | 'en';

const languageMapping: Record<Locale, { icon: string; title: string }> = {
  et: {
    icon: 'flag-ee',
    title: 'ET',
  },
  en: {
    icon: 'flag-gb',
    title: 'EN',
  },
};

const LanguageSelect: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const router = useRouter();
  const { locale, pathname, query, asPath } = router;

  if (!isAuthenticated) {
    return null;
  }

  const setLocale = (newLocale: Locale) => {
    router.push(
      {
        pathname,
        query,
      },
      asPath,
      {
        locale: newLocale,
      }
    );
  };

  return (
    <Button
      icon={languageMapping[locale || 'et'].icon}
      title={languageMapping[locale || 'et'].title}
      intent="discrete"
      menu={
        <Menu>
          <MenuItem
            text="Eesti keeles"
            icon="flag-ee"
            onClick={() => setLocale('et')}
          />
          <MenuItem
            text="In English"
            icon="flag-gb"
            onClick={() => setLocale('en')}
          />
        </Menu>
      }
    />
  );
};

export default LanguageSelect;
